import ApiManager from './crud-manager';

const apiManager = new ApiManager();

export default function jsonToView(jsonData, templateView) {
  const url = `/api/v1/template/getview`;
  const body = {
    ApiTemplate: templateView,
    JData: JSON.stringify(jsonData)
  };

  return apiManager
    .post(url, body)
    .then(response => response)
    .catch(error => {
      throw new Error(error);
    });
}
